import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=46a7af56&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a7af56')) {
      api.createRecord('46a7af56', component.options)
    } else {
      api.reload('46a7af56', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=46a7af56&", function () {
      api.rerender('46a7af56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh5mi9b4R3kc/JS/pricehelp.vue"
export default component.exports